__turbopack_context__.v({
  "className": "traditionalchinesenamefont_c2454a4c-module__94yWaG__className",
});
